/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GeneralInfoTabsUpdatePrivacyMutationVariables = {|
  valuePrivacy: string
|};
export type GeneralInfoTabsUpdatePrivacyMutationResponse = {|
  +staticUrlContent: ?{|
    +file: ?string
  |}
|};
export type GeneralInfoTabsUpdatePrivacyMutation = {|
  variables: GeneralInfoTabsUpdatePrivacyMutationVariables,
  response: GeneralInfoTabsUpdatePrivacyMutationResponse,
|};
*/


/*
mutation GeneralInfoTabsUpdatePrivacyMutation(
  $valuePrivacy: String!
) {
  staticUrlContent(input: {type: PRIVACY, content: $valuePrivacy, lang: "es"}) {
    file
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "valuePrivacy",
    "type": "String!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "content",
            "variableName": "valuePrivacy"
          },
          {
            "kind": "Literal",
            "name": "lang",
            "value": "es"
          },
          {
            "kind": "Literal",
            "name": "type",
            "value": "PRIVACY"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "StaticUrlContentPayload",
    "kind": "LinkedField",
    "name": "staticUrlContent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "file",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralInfoTabsUpdatePrivacyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GeneralInfoTabsUpdatePrivacyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "GeneralInfoTabsUpdatePrivacyMutation",
    "operationKind": "mutation",
    "text": "mutation GeneralInfoTabsUpdatePrivacyMutation(\n  $valuePrivacy: String!\n) {\n  staticUrlContent(input: {type: PRIVACY, content: $valuePrivacy, lang: \"es\"}) {\n    file\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '013340b166f343ff3555866e9619aee8';

module.exports = node;
